<template>
    <div>
        <v-row class="mt-3 ml-3 mr-5">
            <v-col cols="6">
                <v-btn
                    size="small"
                    color="primary"
                    prepend-icon="mdi-arrow-left-bold"
                    @click="$router.push('/AdminPanel')"
                    >
                    Powrót do panelu
                </v-btn>
            </v-col>
            <v-col cols="6">
                <v-row class="mt-8 justify-end">
                    <v-btn
                        size="small"
                        color="secondary"
                        append-icon="mdi-close-circle"
                        @click="$router.push('/AdminOrders')"
                        >
                        Powróć do aktualnych zamówień
                    </v-btn>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="ma-16">
          <v-col cols="12">
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels
                    multiple    
                    >
                        <v-expansion-panel 
                        elevation="0"
                        v-for="(item, i) in Orders"
                        :key="i"
                        variant="outlined"
                        class="pa-3 ma-2"
                        >
                            <v-expansion-panel-title class="text-h6 justify-start">
                                <v-col cols="6"> {{ item.ordernum }}  </v-col>
                                <v-col cols="5">  </v-col>
                                <v-col cols="1"> <v-icon :color="item.finished ? 'success' : 'gray'" :icon="item.finished ? 'mdi-check-circle' : 'mdi-progress-clock'"> </v-icon>  </v-col>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="text-body-1">Zamówione produkty: </span><span class="text-subtitle-2"> {{ item.products }} <span class="font-weight-black">({{ item.price }}zł)</span></span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="text-body-2">Metoda płatności: {{ item.payment }} </span> <br />
                                        <span class="text-body-2">Wykorzystano kod rabatowy: {{ item.coupon }} </span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="4">
                                        <span class="text-body-1">Dane kupującego: </span><br />
                                        <span class="text-caption">{{ item.buyername }}</span> <br />
                                        <span class="text-caption">{{ item.contact }}</span> <br />
                                        <span class="text-caption">{{ item.address }}</span> <br />
                                        <span class="text-caption">{{ item.city }} {{ item.zip_code }} ({{ item.voivodeship }})</span><br />
                                        <span class="text-caption">{{ item.delivery }}</span>
                                    </v-col>
                                    <v-col cols="4">
                                        <span class="text-body-1">Dane do faktury: </span><br />
                                        <div v-if="item.fv_samedata === true"><span class="text-caption">Takie same jak do wysyłki</span></div>
                                        <div v-if="item.fv_samedata !== true">
                                            <span class="text-caption">{{ item.fv_firm }}</span> <br />
                                            <span class="text-caption">{{ item.fv_buyername }}</span> <br />
                                            <span class="text-caption">{{ item.fv_address }}</span> <br />
                                            <span class="text-caption">{{ item.fv_city }} {{ item.fv_zip }} ({{ item.fv_voivodeship }})</span><br />
                                        </div>
                                    </v-col>
                                    <v-col cols="4" class="text-end">
                                        Opłacono: <v-icon :color="item.payed ? 'success' : 'error'" :icon="item.payed ? 'mdi-check-circle' : 'mdi-close-circle'"> </v-icon> <br />
                                        Przesyłka skompletowana: <v-icon :color="item.completed ? 'success' : 'error'" :icon="item.completed ? 'mdi-check-circle' : 'mdi-close-circle'"> </v-icon> <br />
                                        Wysłano: <v-icon :color="item.send ? 'success' : 'error'" :icon="item.send ? 'mdi-check-circle' : 'mdi-close-circle'"> </v-icon> <br />
                                        Zakończono: <v-icon :color="item.finished ? 'success' : 'error'" :icon="item.finished ? 'mdi-check-circle' : 'mdi-close-circle'"> </v-icon> <br />
                                        <span>nr przesyłki: {{ item.delinum }}</span>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
          </v-col>
        </v-row>
    </div>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from "vuex";

  export default {
    data () {
      return {
        coupname: '',
        discount: '',
        msgSnackbar: false,
        Orders: [],
        transport_num: '',
      }
    },
    created() {
      if(this.isLoggedIn !== true){
        this.$router.push('/AdminLogin')
      }
    },
    methods: {
        getOrders() {
            this.Orders = [],

            axios
            .get(`${process.env.VUE_APP_API}/get_orders_archived`, {params: {'admin_token': `${process.env.VUE_APP_ADMIN_TOKEN}`}})
            .then((resp) => {
            this.Orders = resp.data;
            });
        },
    },
    mounted () {
        this.getOrders();
    },
    computed: {
        ...mapGetters(['isLoggedIn']),

        butdis() {
            return (this.transport_num === '')
        }
    }
}
</script>